import React from 'react';
import SEO from '../SEO';
import AnnouncementBar from '../AnnouncementBar';
import Header from './Header';
import HeroSection from './HeroSection';
import ProblemSection from './ProblemSection';
import WhatIsBuildPilot from './WhatIsBuildPilot';
import ScrollingFeaturesSection from './ScrollingFeaturesSection';
import FeatureSection from './FeatureSection';
import HowItWorks from './HowItWorks';
import IntelligenceCallout from './IntelligenceCallout';
import FeaturedArticles from './FeaturedArticles';
import TestimonialsSection from './TestimonialsSection';
import LocationsSection from './LocationsSection';
import PartnerLogosSection from './PartnerLogosSection';
import FAQSection from './FAQSection';
import FinalCta from './FinalCta';
import Footer from './Footer';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <SEO 
        title="BuildPilot | Free Building App Australia | Cost Tracker, Builder Finder & 25+ Tools"
        description="Australia's #1 free building app. Track costs, check builder licences, compare quotes, find tradies, and manage your entire home build or renovation. 25+ free tools for Australian builders and renovators."
        url="https://www.buildpilot.app/"
        keywords="building app Australia, free building app, home building app, cost tracker building, find a builder, builder licence check, building checklist, renovation app Australia, construction app, building tools"
      />
      <AnnouncementBar />
      <Header />
      <main>
        <HeroSection />
        <ProblemSection />
        <WhatIsBuildPilot />
        <ScrollingFeaturesSection />
        <FeatureSection />
        <HowItWorks />
        <IntelligenceCallout />
        <FeaturedArticles />
        <TestimonialsSection />
        <LocationsSection />
        <PartnerLogosSection />
        <FAQSection />
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
